module.exports = "<div class=\"row bgHeading\"><h2>News</h2></div>\n<div class=\"col-12\">\n  <div class=\"col-12\" [innerHtml]=\"intro\"></div>\n  <div class=\"col-12\" [innerHtml]=\"body\"></div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/news/news.component.html
// module id = 326
// module chunks = 1